import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import Thunk from 'redux-thunk';
import ReduxPromise from 'redux-promise';
import reducers from './reducers';
import App from './components/App';
import axios from 'axios';

const createStoreWithMiddleware = createStore(reducers, compose(applyMiddleware(Thunk, ReduxPromise)));

export default function (mountPoint, props) {
    props.accessToken = () => {
        return axios.get('/u/auth/api-token').then((response) => {
            return response.data.access_token;
        });
    };

    ReactDOM.render(
        <Provider store={createStoreWithMiddleware}>
            <App {...props} />
        </Provider>
        , mountPoint
    );
}
